export default function shippingAppOrdersComponent() {
    return {
        initOrders(authID = null) {
            // console.log('Orders Initialized ' + authID);
        },
        // submit Order [Scheduled, Cancelled, No Answer]
        submitOrderWithComment(id, type, orderProducts = null) {

            if (!['Scheduled', 'Cancelled', 'No Answer', 'Delivered'].includes(type) ) {
                Swal.fire("Data Not Valid", "Place Enter Status Valid !", "error");
                return;
            }
            var order_status = '';
            var data_html = ``;
            if (type === 'Scheduled') {
                order_status = "تأجل";
                data_html += `
                    <div class="form-group d-none" data-format="yyyy-MM-dd">
                        <input type="text" name="date" data-field="date" data-format="dd-MM-yyyy" id="date-${id}" readonly>
                        <label class="col-form-label">التاريخ</label>
                        <div id="swal-scheduled-date-${id}"></div>
                    </div>
                    <div class="form-group d-none">
                        <input type="text" name="time" data-field="time" data-format="hh:mm AA" id="time-${id}" readonly>
                        <label class="col-form-label">الوقت</label>
                       <div id="swal-scheduled-time-${id}"></div>
                    </div>`;
            } else if (type === 'Delivered') {
                order_status = "تسلم";
                data_html += `
                     <div id="containt-uncompleted-${id}" class="form-group d-none">
                        <div class="alert alert-warning" role="alert">
                            <i data-feather="alert-circle"></i>
                            في حاله كانت الكميه ازيد من المطلوب في الاوردر يجب التأكد من توافر الكميه فى المخزون الخاص بك
                        </div>

                           <table class="table table-striped-table-bordered table-hover table-checkable">
                            <thead>
                            <tr>
                                <td><span>اسم المنتج</span></td>
                                <td><span>الكمية </span></td>
                                <td><span>السعر </span></td>
                            </tr>
                            </thead>
                            <tbody>`;

                console.log(orderProducts);

                for (const [key, orderProduct] of Object.entries(orderProducts)) {
                    data_html += `<tr>
                        <td><input type="hidden" name="name[]" id="swal-name-${key}" class="swal2-input mr-3" min="1" value="${orderProduct.name}" disabled readonly>
                            <input type="hidden" name="product_id[]" id="swal-productId-${key}" class="swal2-input mr-3" min="1" value="${orderProduct.id}"></td>
                        <td><input type="number" name="quantity[]" id="swal-quantity-${key}" class="swal2-input mr-3" min="1" oninput="validity.valid||(value='');" placeholder="الكميه" value="${orderProduct.pivot.quantity}"></td>
                        <td><input type="number" name="price[]" id="swal-price-${key}" class="swal2-input mr-3" min="1" oninput="validity.valid||(value='');" placeholder="السعر" value="${orderProduct.pivot.price}"></td>
                    </tr>`;
                }

                data_html += `
                        </tbody>
                        </table>

                        <input type="number" name="total_price" id="swal-total-price-${id}" class="swal2-input mr-3" min="1" oninput="validity.valid||(value='');" placeholder="اجمالى السعر">

                    </div>`;

            } else if (type === 'No Answer') {
                order_status = "تعلق على"
            } else if (type === 'Cancelled') {
                order_status = "تلغي"
            }

            Swal.fire({
                title: `.سوف ${order_status} هذا الاوردر`,
                html: `${this.loadCommentsSelect(id, window.shippingAgentComments['shipping ' + type.toLowerCase()]) + data_html}  <textarea id="swal-notes-${id}" class="swal2-textarea" placeholder="ملاحظة" style="text-align: right;"></textarea>`,
                showCancelButton: true,
                confirmButtonText: "تأكيد",
                cancelButtonText: "إلغاء",
                showLoaderOnConfirm: true,
                onOpen: () => {
                    if(type === 'No Answer') {
                        var comment = document.getElementById(`swal-comment-${id}`);
                        comment.style.display = 'none';
                        comment.querySelectorAll('option[value="CLIENT_NO_ANSWER"]')[0].setAttribute('selected', 'selected');
                    } else if (type === 'Scheduled') {
                        $(document).ready(function(){
                            $(`#swal-scheduled-time-${id}, #swal-scheduled-date-${id}`).DateTimePicker();
                        });
                    }

                },
                preConfirm: (value) => {
                    return new Promise((resolve) => {

                        var comment = document.getElementById(`swal-comment-${id}`).value,
                            notes = document.getElementById(`swal-notes-${id}`).value,
                            products = [];

                        if (type === 'Scheduled') {
                            var schedule_date = document.getElementById(`date-${id}`),
                                schedule_time = document.getElementById(`time-${id}`);
                        } else if (type === 'Delivered') {
                            let productIDs = document.getElementsByName('product_id[]');
                            let quantitys = document.getElementsByName('quantity[]');
                            let names = document.getElementsByName('name[]');
                            let prices = document.getElementsByName('price[]');
                            var product_id = [];
                            var quantity= [];
                            var price= [];
                            var name= [];
                            var products= [];

                            for (let i = 0; i < productIDs.length; i++) {
                                products.push({
                                    'product_id': productIDs[i].value,
                                    'quantity': quantitys[i].value,
                                    'price': prices[i].value,
                                    'name': names[i].value,
                                });
                            }

                            // var quantity = document.getElementById(`swal-quantity-${id}`),
                            //     price = document.getElementById(`swal-price-${id}`);
                        }

                        axios.post(`/sa/api/orders/${id}/submit-order`,{
                            orderId: id,
                            status: type,
                            comment,
                            // quantity: quantity ? quantity.value : '',
                            // price: price?.value,
                            products,
                            // product_id,
                            // quantity,
                            // price,
                            schedule_date: schedule_date ? schedule_date.value : '',
                            schedule_time: schedule_time ? schedule_time.value : '',
                            notes,
                        }).then(function (response) {
                            Swal.fire("Suceess", `${type} Order Successfully !`, "success");
                            window.location.href = "/sa/orders/order-management";
                            setTimeout(function(){
                                location.reload();
                            }, 1000);

                        }, error => {
                            // handling errors
                            if (error.response.data.errors) {
                                Swal.showValidationMessage(
                                    this.printErrorMsg(error.response.data.errors)
                                )
                            } else {
                                this.handleResponseError(error.response.data);
                            }
                            resolve();
                        });
                    })

                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (typeof(result.value) == 'undefined') {
                    return false;
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    // text: response.data.message,
                    // footer: '<a href="">Why do I have this issue?</a>'
                });
            })
                .catch(error => {
                    console.log(error);
                    Swal.fire(
                        'Oops!',
                        error.response.data.error,
                        'error'
                    )
                })



            $(`#swal-comment-${id}`).on('change', function () {
                if ($(this).val() === 'PARTIAL_DELIVERY') {

                    // $(`#swal-quantity-${id}`).attr('max', count_P_I_S); //
                    $(`#containt-uncompleted-${id}`).removeClass('d-none');
                } else {
                    $(`#containt-uncompleted-${id}`).addClass('d-none');
                }
            });

        },

        loadCommentsSelect(id, comments) {
            var data_select = '';
            Object.keys(comments).forEach(key => {
                data_select += `<option value="${key}">${comments[key]}</option>`;
            });

            data_select = `<div class="form-group">
                    <select id="swal-comment-${id}" class="swal2-select form-control select2" required>
                    <option value>اختر التعليق المناسب</option>
                    ${data_select}
                    </select>
                </div>`;
            return data_select;
        },

        printErrorMsg (msg) {
            var ulElements = '';
            $.each( msg, function( key, value ) {
                ulElements += `<li>${value[0]}</li>`;
            });
            return `<div class="alert alert-danger print-error-msg">${ulElements}</div>`;
        },

        handleResponseError(error) {
            if (error.errors) {
                let errors = error.errors

                for (key in errors) {

                    Toast.fire({
                        icon: 'error',
                        title: errors[key][0]
                    })
                }
            } else {
                Toast.fire({
                    icon: 'error',
                    title: error.message
                })
            }
        },

        startDeliverOrder($event, orderId, href) {
            Swal.fire({
                title: "Are you sure ?",
                text: "سوف تقوم ببدأ توصيل الاوردر .",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, change it !",
                cancelButtonText: "No, cancel !",
                closeOnConfirm: false,
                closeOnCancel: false
            }).then((confirmed) => {
                if (confirmed.value == true) {

                    Swal.fire("Suceess", `تم بدأ تنفيذ الاوردر بنجاح`, "success");

                    setTimeout(function(){
                        window.location = href;
                    }, 1000);
                } else if(confirmed.dismiss == "cancel") {
                    Swal.fire("Cancelled", "Status Unchanged !", "error");
                }

            });

        },

    }
}
